import { render, staticRenderFns } from "./EmailReminder.vue?vue&type=template&id=96c764fe&lang=pug&"
import script from "./EmailReminder.vue?vue&type=script&lang=ts&"
export * from "./EmailReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports